import axios from "axios";
import config from "../../config";

const BASE_URL = `${config.url}/api/highlights`;

const BookHighlightManager = {
  async getAllHighlights() {
    const response = await axios.get(BASE_URL);
    return response.data.responseData;
  },

  async getHighlightById(id) {
    const response = await axios.get(`${BASE_URL}/${id}`);
    return response.data.responseData;
  },


  async getHighlightsByType(type) {
    const response = await axios.get(`${BASE_URL}/type/${type}`);
    return response.data.responseData;
  },

  async getBookOfTheMonth(userId = null) {
    const response = await axios.post(`${BASE_URL}/book-of-the-month`, {
      userId,
    });
    return response.data.responseData;
  },

  async getJustLaunchedBooks(userId = null) {
    const response = await axios.post(`${BASE_URL}/just-launched`, {
      userId,
    });
    return response.data.responseData;
  },

  async getTrendingBooks(userId = null) {
    const response = await axios.post(`${BASE_URL}/trending`, {
      userId,
    });
    return response.data.responseData;
  },

  async getBestReadsBooks(userId = null) {
    const response = await axios.post(`${BASE_URL}/best-reads`, {
      userId,
    });
    return response.data.responseData;
  },
};

export default BookHighlightManager;
